/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { MenuItem, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getPriceTypeDetails } from '../../../store/action';

const PriceInputContainer = ({
  details = [],
  priceTypeDetails = [],
  setSelectedPriceType,
  selectedPriceType,
  fullScreen,
  setFullScreen,
}) => {
  const [existingPriceType, setExistingPriceType] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPriceTypeDetails());

    if (details && details.length > 0) {
      const filteredValue = [
        ...new Set(
          details.map((item) => item.priceId && item.priceId.priceTypeCd)
        ),
      ];
      setExistingPriceType(filteredValue);
    } else {
      setExistingPriceType([]);
    }
  }, []);

  return (
    <div className="row col-12 align-items-center">
      <div className="col-4">
        <div className="mui-custom-form with-select w-100">
          <TextField
            id="PriceType"
            label="Price Type"
            select
            // disabled
            inputProps={{ 'aria-label': 'PriceType',"id":"PriceType"}}
            value={selectedPriceType || 'GNUP'}
            placeholder=""
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              setSelectedPriceType(e.target.value);
            }}
          >
            <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
            {priceTypeDetails && priceTypeDetails.length > 0
              ? priceTypeDetails.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.priceTypeCd} className="frr-logcheck-dropdown-item">
                      {`${item.priceTypeCd}${
                        item.longDescr ? ` | ${item.longDescr}` : ''
                      }`}
                    </MenuItem>
                  );
                })
              : null}
          </TextField>
        </div>
      </div>
      <div className="col-8">
        <div className="mui-custom-form with-select input-md w-100">
          <fieldset className="custom-fieldset">
            <legend>Existing Price Types</legend>
            <div className="form-wrapper">
              {existingPriceType.length > 0
                ? existingPriceType.join(',  ')
                : null}
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default PriceInputContainer;
